import { GetStaticProps, NextPage } from 'next'
import { ContactPage } from '~pages/contact-page/contact-page'
import { getCategoriesData } from '~shared/api/categories/getCategories'
import { getPopularPrograms } from '~shared/api/programs-popular/getPopularPrograms'
import { getFooterData } from '~shared/api/footer/getFooterData'
import { ENV } from '~shared/constants/env'

type TProps = {
  categories: Awaited<ReturnType<typeof getCategoriesData>>
  footer: Awaited<ReturnType<typeof getFooterData>>
  popularPrograms: Awaited<ReturnType<typeof getPopularPrograms>>
}

const NextContactPage: NextPage<TProps> = ({
  categories,
  footer,
  popularPrograms
}) => {
  return (
    <ContactPage
      categories={categories}
      footer={footer}
      popularPrograms={popularPrograms}
    />
  )
}

export const getStaticProps: GetStaticProps = async context => {
  try {
    const [categories, footer, popularPrograms] = await Promise.all([
      getCategoriesData({ context }),
      getFooterData({ context }),
      getPopularPrograms({ context })
    ])

    return {
      props: {
        categories: categories || null,
        footer: footer || null,
        popularPrograms: popularPrograms || null
      },
    }
  } catch (err) {
    console.error(err)
    return { props: {} }
  }
}

export default NextContactPage
